{
  "asset_id": "864ab7e4-e49a-4817-8896-809863bad123",
  "content_type": "image/png",
  "created_at": "2026-08-18T02:40:45Z",
  "original_filename": "central-dispatch-member-badge.png",
  "project_id": "2812fb56-05a3-4ec8-9702-5d2e0c03689d",
  "r2_key": "a/v1/2812fb56-05a3-4ec8-9702-5d2e0c03689d/864ab7e4-e49a-4817-8896-809863bad123/central-dispatch-member-badge.png",
  "size": 74653,
  "url": "/__l5e/assets-v1/864ab7e4-e49a-4817-8896-809863bad123/central-dispatch-member-badge.png",
  "version": 1
}